export * from './permission-page/permission-page.component';
export * from './permission-listing-page/permission-listing-page.component';
export * from './resources-item/resources-item.component';
export * from './affiliate-types-page/affiliate-types-page.component';
export * from './payout-methods-page/payout-methods-page.component';